export default () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_453_2871)">
        <path
          d="M11.25 17.8125H18.75"
          stroke="#7C7C78"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 14.0625H18.75"
          stroke="#7C7C78"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 4.6875H23.4375C23.6861 4.6875 23.9246 4.78627 24.1004 4.96209C24.2762 5.1379 24.375 5.37636 24.375 5.625V25.3125C24.375 25.5611 24.2762 25.7996 24.1004 25.9754C23.9246 26.1512 23.6861 26.25 23.4375 26.25H6.5625C6.31386 26.25 6.0754 26.1512 5.89959 25.9754C5.72377 25.7996 5.625 25.5611 5.625 25.3125V5.625C5.625 5.37636 5.72377 5.1379 5.89959 4.96209C6.0754 4.78627 6.31386 4.6875 6.5625 4.6875H11.25"
          stroke="#7C7C78"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.3125 8.4375V7.5C10.3125 6.2568 10.8064 5.06451 11.6854 4.18544C12.5645 3.30636 13.7568 2.8125 15 2.8125C16.2432 2.8125 17.4355 3.30636 18.3146 4.18544C19.1936 5.06451 19.6875 6.2568 19.6875 7.5V8.4375H10.3125Z"
          stroke="#7C7C78"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_453_2871">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
